var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00708008H513V341.993H0V-0.00708008Z",
    fill: "#095FAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342 -0.00708008H513V341.993H342V-0.00708008ZM0 -0.00708008H171V341.993H0V-0.00708008Z",
    fill: "#BE1229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.3 166.293H123.1V240.493H108.3V166.293ZM48.8999 166.293H63.6999V240.493H48.8999V166.293Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9997 218.193C94.1735 218.193 100.8 211.567 100.8 203.393C100.8 195.219 94.1735 188.593 85.9997 188.593C77.8259 188.593 71.1997 195.219 71.1997 203.393C71.1997 211.567 77.8259 218.193 85.9997 218.193Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1997 225.693H100.9V240.493H71.1997V225.693ZM71.1997 166.293H100.9V181.093H71.1997V166.293Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9997 158.793C94.1735 158.793 100.8 152.167 100.8 143.993C100.8 135.819 94.1735 129.193 85.9997 129.193C77.8259 129.193 71.1997 135.819 71.1997 143.993C71.1997 152.167 77.8259 158.793 85.9997 158.793Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2998 123.893H95.7998L85.9998 108.293L76.2998 123.893Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00708008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMn);
export default __webpack_public_path__ + "static/media/MN.6aef56dc7791f6b574799afd9aa1a4fc.svg";
export { ForwardRef as ReactComponent };